// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__19KmC","name":"ConsentHeader_name__22uQL","birthday":"ConsentHeader_birthday__dvYh6","skeleton":"ConsentHeader_skeleton__22q_p"};